<template src="./AppFooter.html"></template>

<script lang="ts">
import { defineComponent } from "vue";
import packageJson from "@/../package.json";

export default defineComponent({
    data() {
        return {
            version: packageJson.version
        };
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
});
</script>

<style src="./AppFooter.scss" lang="scss" scoped></style>
